const footerNavLegal = [
    {
        label: "Privacy Policy",
        href: "/privacy-policy",
    },
    {
        label: "Cookie Notice",
        href: "/cookie-notice",
    },
    {
        label: "Terms of Use",
        href: "/termsofuse"
    },
    {
        label: "Transparency in Supply Chain Statement",
        href: "https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/Supply_Chain/Transparency_in_Supply_Chain_Statement.pdf",
        isExternal: true
    }
];

export default footerNavLegal;